/*
  全局过期器定义
  注意：1. 使用字符类型表示key值；2. 使用'default'表示默认值；3.当没有定义'default'值时，将返回空字符串
 */
const filters = {
  FILTER_IsPublish: {
    '0': '未启用',
    '1': '启用',
    'default': '-'
  },
  FILTER_IsPublish_Class: {
    '0': 'wt-tag',
    '1': 'wt-tag success',
    'default': 'wt-tag'
  },
  FILTER_Gender: {
    '0': '-',
    '1': '男',
    '2': '女'
  },
  FILTER_Warning_State: {
    '0': '-',
    '1': '待处理',
    '2': '已延迟',
    '3': '已解决'
  },
  FILTER_Delivery_State: {
    '0': '-',
    '1': '线下',
    '2': '投递柜',
    '3': '代投',
    '4': '扫描固定二维码'
  },
  FILTER_Order_type: {
    '0': '-',
    '1': '自提',
    '2': '售货柜',
    '3': '代换'
  },
  FILTER_Threshold_type: {
    '1': '益点通对接',
    'default': '-'
  },
  FILTER_Company: {
    '4': '显示碳百可（北京）环保科技有限公司-首开',
    'default': '-'
  }
}

export default filters
